import React from 'react';
import confirm from '../../utils/confirm';
import DialogComponent from '../widgets/dialog/DialogComponent';
import CollectionService from '../../services/collection-service';
import { TextField } from '../widgets';

export default class PrepareSubmit extends DialogComponent {

  private service = new CollectionService();

  state = {
    password: '',
    uploading: false,
  }

  render() {
    const { dialogInstance, children, ...props } = this.props as any;
    console.log(props);

    const keys = Object.keys(props);
    console.log('keys are', keys);

    return (
      <div className="collection-prepare-submit">
        <div className="row ltr text-left">
          {keys.map(key => (
            <React.Fragment key={key}>
              <div className="col-6">{key}</div>
              <div className="col-6">{JSON.stringify(props[key])}</div>
            </React.Fragment>
          ))}
          <div className="col-12 ltr text-left mt-3 p-0">
            <TextField
              autoFocus
              type="password"
              hint="Enter Your Password"
              onTextChange={this.handlePasswordChange}
            />
          </div>
          <div className="col-12 mt-4 d-flex justify-content-center">
            <button
              onClick={this.handleClick}
              {...this.attrButton()}
              className="ant-btn ant-btn-lg ant-btn-primary mx-auto">ارسال اطلاعات</button>
          </div>
        </div>
      </div>
    );
  }

  attrButton = () => {
    if (this.state.uploading || this.state.password.trim() === '') {
      return { disabled: true };
    }
    return {};
  }

  handlePasswordChange = (event) => {
    this.setState({ password: event.target.value });
  }

  handleClick = () => {
    const { model, type, condition, value, keyId } = this.props as any;
    const { password } = this.state;
    const data = {
      model,
      condition: JSON.parse(condition),
      value,
      key: keyId,
      password
    };
    this.setState({ uploading: true }, async () => {
      try {
        if (type === 'create') {
          await this.service.create(data);
        }
        else {
          await this.service.update(data);
        }
        this.close(true);
      }
      catch (err) {
        const confirmErrorOptions = {
          rtl: true,
          type: 'error',
          size: 'small',
          primaryClass: 'd-none',
          cancelText: 'باشه',
          onSubmit: () => { }
        }
        this.close(false);
        if (err.response && err.response.status) {
          if (err.response.status === 401) {
            confirm({
              ...confirmErrorOptions,
              title: 'خطا در احرازهویت - کلمه عبور اشتباه است',
            } as any).show();
          }
          else {
            confirm({
              ...confirmErrorOptions,
              title: err.message
            } as any).show();
          }
        }
      }
    });
  }

}
